<template>
  <div class="chat-window" ref="chatWindow">
    <div class="messages-container">
      <ChatMessage 
        v-for="(message, index) in allMessages" 
        :key="index"
        :message="message"
        @product-selected="handleProductSelection"
      />
      
      <!-- Typing Indicator -->
      <div v-if="isLoading" class="typing-indicator">
        <div class="typing-bubble">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
      
      <!-- Empty state -->
      <div v-if="allMessages.length === 0 && !isLoading" class="empty-state">
        <p>Loading chat...</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ChatMessage from './ChatMessage.vue'

export default {
  name: 'ChatWindow',
  components: {
    ChatMessage
  },
  computed: {
    ...mapGetters([
      'allMessages',
      'isLoading'
    ])
  },
  methods: {
    ...mapActions([
      'selectProduct'
    ]),
    
    async handleProductSelection(payload) {
      const conversationId = await this.selectProduct(payload);
      if (conversationId && this.$route.path === '/'){
        this.$router.push(`/chat/${conversationId}`).catch(() => {});
      }
    },
    
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.chatWindow;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    }
  },
  watch: {
    allMessages: {
      handler() {
        this.scrollToBottom();
      },
      deep: true
    },
    isLoading() {
      this.scrollToBottom();
    }
  },
  mounted() {
    this.scrollToBottom();
  }
}
</script>

<style scoped>
.chat-window {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background: #f8f9fa;
  scroll-behavior: smooth;
}

.messages-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Typing Indicator */
.typing-indicator {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 8px;
}

.typing-bubble {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  border-bottom-left-radius: 4px;
  padding: 12px 16px;
  display: flex;
  gap: 4px;
  align-items: center;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.7);
  animation: typing 1.4s infinite;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typing {
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.7;
  }
  30% {
    transform: translateY(-10px);
    opacity: 1;
  }
}

/* Custom scrollbar */
.chat-window::-webkit-scrollbar {
  width: 8px;
}

.chat-window::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.chat-window::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

.chat-window::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-state p {
  font-size: 16px;
  margin: 0;
}
</style>